<script>
export default {
  props: {
    campaignOverview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    overviewChart() {
      const data = this.campaignOverview.engagement_per_day.reduce((result, item) => {
        result.push([item.date, item.value])
        return result;
      }, [])

      return {
        series: [{
          name: 'Eng.',
          data: data
        }],
        chartOptions: {
          chart: {
            type: 'area',
            height: 240,
            toolbar: 'false',
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          markers: {
            size: 0,
            style: 'hollow',
          },
          xaxis: {
            type: 'datetime',
            // tickAmount: 6,
          },
          tooltip: {
            x: {
              format: 'dd MMM yyyy'
            }
          },
          colors: ['#00B2CF'],
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.6,
              opacityTo: 0.05,
              stops: [42, 100, 100, 100]
            }
          },
        }
      };
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-3">Engagement Timeline</h4>

      <div>
        <div id="overview-chart" class="apex-charts" dir="ltr">
          <div class="toolbar button-items text-center">
            <!--                  <button type="button" class="btn btn-light btn-sm" id="one_month">1M</button>-->
            <!--                  <button type="button" class="btn btn-light btn-sm" id="six_months">6M</button>-->
            <!--                  <button type="button" class="btn btn-light btn-sm active" id="one_year">1Y</button>-->
            <!--                  <button type="button" class="btn btn-light btn-sm" id="all">ALL</button>-->
          </div>
          <apexchart
              class="apex-charts"
              type="area"
              height="275"
              dir="ltr"
              :series="overviewChart.series"
              :options="overviewChart.chartOptions"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>
